// src/utils/seoText.js
//
// Hulpfuncties om uit Strapi-content een platte meta-description te maken.
// Bewust CommonJS: dit bestand wordt zowel door de React-app geïmporteerd als
// door scripts/prerender-head.js, dat met plain node draait. Eén bron van
// waarheid, zodat de statische head en de tags die React later zet gelijk zijn.

// Strapi blocks zijn geneste objecten; hieruit halen we de leesbare tekst.
function blocksToText(blocks) {
  if (!Array.isArray(blocks)) return '';
  const walk = (node) => {
    if (!node) return '';
    if (typeof node.text === 'string') return node.text;
    if (Array.isArray(node.children)) return node.children.map(walk).join('');
    return '';
  };
  return blocks.map(walk).join(' ').replace(/\s+/g, ' ').trim();
}

function truncate(text, max = 160) {
  if (!text) return '';
  const clean = String(text).replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  // Knip op een woordgrens, zodat er geen half woord met puntjes blijft staan.
  const cut = clean.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');
  return `${(lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd()}...`;
}

// Accepteert een string of Strapi blocks en levert altijd een platte string op.
// Voorkomt de "[object Object]"-description die ontstaat als blocks
// rechtstreeks in een meta-tag belanden.
function toDescription(value, fallback = '', max = 160) {
  if (Array.isArray(value)) {
    const text = blocksToText(value);
    return text ? truncate(text, max) : fallback;
  }
  if (typeof value === 'string' && value.trim()) {
    return truncate(value, max);
  }
  return fallback;
}

// De beschrijving van Doorloopjes zelf: de head van de homepage (prerender en de standaard van SEO.js),
// de structured data van de landingspagina en llms.txt lezen allemaal deze ene tekst.
const SITE_DESCRIPTION =
  'Korte doorloopjes voor leraren, direct toepasbaar in de klas. Met webinars en een assistent voor je vragen.';

// Description van het publieke overzicht /alle-doorloopjes, voor de pagina en de prerender.
const ALLE_DOORLOOPJES_DESCRIPTION =
  'Korte stappenplannen voor leraren en schoolteams, per thema: direct toepasbaar in de klas, met het onderwijsonderzoek erachter.';

module.exports = { blocksToText, truncate, toDescription, SITE_DESCRIPTION, ALLE_DOORLOOPJES_DESCRIPTION };
